import { render, staticRenderFns } from "./BankFeeds.vue?vue&type=template&id=58c9c3b4&"
import script from "./BankFeeds.vue?vue&type=script&lang=js&"
export * from "./BankFeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports